export default "__VITE_ASSET__D4Qz_Dud__"